export default "__VITE_ASSET__89804016__"